import React from 'react';
import { Modal, Button } from 'react-bootstrap';

export const ReportError = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Error al enviar reporte</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Ocurrio un problema al enviar los reportes, porfavor intenta nuevamente.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button  
          style={{marginRight: '10px', backgroundColor: '#933A16', borderColor: '#933A16'}}
          onClick={handleClose}>
          Volver
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
